import { createStyles, em, rem } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  container: {
    margin: "0",
    minHeight: "100vh",
  },
  leftCol: {
    padding: 0,
    backgroundColor: "white",
  },
  rightCol: {
    backgroundColor: "#FBF8F3",
    padding: 0,
    "@media (max-width: 768px)": {
      display: "none",
    },
  },
  rightContent: {
    height: "100%",
    width: "100%",
    position: "relative",
    overflow: "hidden",
  },
  linePattern1Parent: {
    position: "absolute",
    top: -320,
    right: 2,
    zIndex: 1,
    "& svg": {
      color: "#FFAF4A",
    },
  },
  linePattern2Parent: {
    position: "absolute",
    bottom: -325,
    left: 0,
    zIndex: 1,
    "& svg": {
      color: "#FFF",
    },
  },
  dashboardImg: {
    width: "85%",
    height: "75%",
    objectFit: "fill",
    zIndex: 10,
  },
  leftContent: {
    padding: "20px 32px 96px 32px",
    height: "100%",
    width: "100%",
    "@media (max-width: 420px)": {
      padding: "20px 20px 96px 20px",
    },
  },
  formAndHdngWrapper: {
    flex: 1,
    width: "100%",
    maxWidth: 360,
  },
  signupLinkText: {
    "& .signupLink": {
      textDecoration: "none",
      fontSize: 14,
      fontWeight: 600,
      fontFamily: "Inter",
      color: "#FFAF4A",
    },
  },
  inputField: {
    "& .mantine-InputWrapper-label": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#404040",
      marginBottom: 6,
    },
    "& .mantine-Input-wrapper": {
      padding: "10px 14px",
      height: 44,
      borderRadius: 8,
      border: "1px solid #D0D5DD",
      background: "transparent",
      boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
      "& input, & .mantine-PasswordInput-input": {
        height: "100%",
        border: "none",
        padding: "0px",
        background: "transparent",
        minHeight: "unset",
        fontSize: 16,
        fontWeight: 400,
        fontFamily: "Inter",
        color: "#171717",

        "&:-webkit-autofill": {
          boxShadow: "0 0 0px 1000px transparent inset !important",
          WebkitTextFillColor: "#171717",
          transition: "background-color 5000s ease-in-out 0s",
        },

        "&::placeholder": {
          color: "#737373",
        },
      },
    },
  },
  forgotPasswordLink: {
    display: "block",
    textAlign: "right",
    textDecoration: "none",
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    marginBlock: 24,
  },
  loginBtn: {
    width: "100%",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
}));

export default useStyles;
